export const formatDriverName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string => {
  return [firstName, lastName]
    .map((part) => {
      return (part ?? '').trim()
    })
    .filter((part) => {
      return part !== ''
    })
    .join(' ')
}
